// extracted by mini-css-extract-plugin
export default {"loadingGif":"styles_loadingGif__8E2up"};